import React from 'react';

import cx from 'classnames';
import GraphemeSplitter from 'grapheme-splitter';

import { RhythmScoreBadge, YatSprite } from '@pkg/components';

import { getGlowLevel, type GlowLevelTypes } from '@app/helpers';

import './YatTile.scss';

const graphemeSplitter = new GraphemeSplitter();
export enum YatTileVariant {
    default = 'default',
    nebula = 'nebula',
}

export interface YatTileProps {
    /** String representation of yat */
    yat: string;
    /** Yat's rhythm score */
    rhythmScore: number;
    /** Should the rhythm score be shown? */
    showRhythmScore?: boolean;
    /** Generation of the Yat */
    generation?: number;
    /** Should the glow style be applied? */
    glow?: boolean;
    /** Should the shadow style be applied? */
    shadow?: boolean;
    /** Should the Tile show only the first emoji? */
    singleEmoji?: boolean;
    /** The style variant of the YatTile */
    variant?: YatTileVariant;
    /** Class string to append to YatTile's class string */
    classes?: string;
    /** Should the YatTile force the use of Yat's custom emoji images? */
    forceSprite?: boolean;
    /** Handler for click events */
    onClick?: () => void;
}

export const YatTile = ({
    yat,
    rhythmScore,
    showRhythmScore = true,
    generation,
    glow = false,
    shadow = false,
    singleEmoji = false,
    classes = '',
    forceSprite,
    onClick,
    variant = YatTileVariant.default,
}: YatTileProps) => {
    const glowLevel: GlowLevelTypes = getGlowLevel(rhythmScore);
    const classNames = cx(
        'yat-tile',
        `yat-tile--variant-${variant}`,
        {
            [`yat-tile--generation-${generation}`]: generation,
            [`yat-tile--${glowLevel}`]: glowLevel,
            'yat-tile--single-emoji': singleEmoji,
        },
        classes,
    );

    return (
        <div className={classNames} onClick={onClick}>
            {glow && <div className="yat-tile__glow" />}
            {shadow && <div className="yat-tile__shadow" />}
            <div className="yat-tile__inner">
                {graphemeSplitter.splitGraphemes(yat).map((emoji, i) => (
                    <YatSprite forceSprite={forceSprite} key={i} emojiID={emoji} />
                ))}
            </div>
            {showRhythmScore && !!rhythmScore && (
                <RhythmScoreBadge score={rhythmScore} classes="yat-tile__rhythm-score" />
            )}
        </div>
    );
};
